import { render, staticRenderFns } from "./dependenciesList.vue?vue&type=template&id=5e2a6c3f&scoped=true&"
import script from "./dependenciesList.vue?vue&type=script&lang=js&"
export * from "./dependenciesList.vue?vue&type=script&lang=js&"
import style0 from "./dependenciesList.vue?vue&type=style&index=0&id=5e2a6c3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a6c3f",
  null
  
)

export default component.exports